import Vue from 'vue'
import Meta from 'vue-meta'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

// Vue-Meta
Vue.use(Meta)

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

// Animate
import AnimateCSS from 'animate.css'
Vue.use(AnimateCSS)

// Socket.io
import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
  // debug:true,
  connection: `${process.env.VUE_APP_BACKEND}`,
}))

// Vue-Router
import router from './router'

// Google Analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: `${process.env.VUE_APP_GTAG}` }
}, router);

new Vue({
  router,
  store,
  render: h => h(App),
  sockets: {
    connect: function () {
        console.log('socket connected!')
    },
    reconnect: function () {
      // setTimeout(() => window.location.reload(), 60000)
    },
    reload: function () {
      window.location.reload();
    }
  }
}).$mount('#app')